  import { useState, useEffect } from "react";
  import { Col, Form, Row } from "react-bootstrap";
  import { useSelector } from "react-redux";
  import AnimatedSelect from "../../../shared/AnimatedSelect";
  import "../../../shared/AnimatedSelect.css";


  const UserBehaviorFilters = ({ filterValues = {}, campaign, journeys, lists, features, landingpage,ChannelList,ContentList,SolutionList, onFilterChange }) => {
    const [selectedFilter, setSelectedFilter] = useState(filterValues.specificBehavior || "");
    const [subFilter, setSubFilter] = useState(filterValues.behaviorAttribute || "");

    // Get social pages from Redux store
    const filter_dropdowns = useSelector(state => state.journey?.filter_dropdowns) || {};
    const socialPages = filter_dropdowns?.social || [];

    // Keep local UI state in sync when parent provides prefilled values
    useEffect(() => {
      setSelectedFilter(filterValues.specificBehavior || "");
    }, [filterValues.specificBehavior]);

    useEffect(() => {
      setSubFilter(filterValues.behaviorAttribute || "");
    }, [filterValues.behaviorAttribute]);

    // Main Filters for User Behavior
    const filterOptions = {
      Login: ["Last Login", "Number of times logged in"],
      Share: [], 
      "Got Leads": [], 
      "Imported Contacts": [],
      "Updated Profile": [],
      "Created Tasks": [],
      "Opened Notifications": [],
      "Clicked Links (in Email/WhatsApp/Push)": [],
      //"Completed Actions / Journeys": [], 
      "Sync Contacts": ["gmail", "phone"],
      "AutoEmail Contacts": [],
      "Inactive Users": [],
      "Account Created On": [],
      "Social Pages": [],
    };

    // Sub-options for dropdowns
    const contentTypes = ["Documents", "Videos", "Images"];

    return (
      <>
          <Col className="custom_col">
            <AnimatedSelect
              value={filterValues.hasDone || "HasDone"}
              options={[
                { label: "Has Done", value: "HasDone" },
                { label: "Has Not Done", value: "HasNotDone" }
              ]}
              onChange={(value) => onFilterChange && onFilterChange("hasDone", value)}
            />
          </Col>

        {/* Main Filter Select */}
        <Col className="custom_col">
          <AnimatedSelect
            value={selectedFilter}
            options={[
              { label: "Select Behavior", value: "" },
              ...Object.keys(filterOptions).map((main) => ({
                label: main,
                value: main
              }))
            ]}
            onChange={(value) => {
              setSelectedFilter(value);
              setSubFilter("");
              onFilterChange && onFilterChange("specificBehavior", value);
            }}
          />
        </Col>

        {/* Sub Filter Select (only when behavior has inner options) */}
        {selectedFilter &&
          filterOptions[selectedFilter].length > 0 && (
            <Col className="custom_col">
              <AnimatedSelect
                value={subFilter}
                options={filterOptions[selectedFilter].map((sub) => ({
                  label: sub,
                  value: sub
                }))}
                onChange={(value) => {
                  setSubFilter(value);
                  onFilterChange && onFilterChange("behaviorAttribute", value);
                }}
              />
            </Col>
          )}

        {/* ============ CONDITIONAL FIELDS ============ */}

        {/* LOGIN */}
        {selectedFilter === "Login" && subFilter === "Last Login" && (
          <>
            <Col className="custom_col">
              <Form.Control 
                type="date" 
                placeholder="Start Date" 
                value={filterValues.startDate || ""}
                onChange={(e) => onFilterChange && onFilterChange("startDate", e.target.value)}
              />
            </Col>
            <Col className="custom_col">
              <Form.Control 
                type="date" 
                placeholder="End Date" 
                value={filterValues.endDate || ""}
                onChange={(e) => onFilterChange && onFilterChange("endDate", e.target.value)}
              />
            </Col>
          </>
        )}
        {selectedFilter === "Login" && subFilter === "Number of times logged in" && (
          <>
          <Col className="custom_col">
            <Form.Control 
              type="number" 
              placeholder="Enter count" 
              value={filterValues.numberOfTimesLoggedIn || ""}
              onChange={(e) => onFilterChange && onFilterChange("numberOfTimesLoggedIn", e.target.value)}
            />
          </Col>
            <Col className="custom_col">
            <Form.Control 
              type="date" 
              placeholder="Start Date" 
              value={filterValues.startDate || ""}
              onChange={(e) => onFilterChange && onFilterChange("startDate", e.target.value)}
            />
          </Col>
          <Col className="custom_col">
            <Form.Control 
              type="date" 
              placeholder="End Date" 
              value={filterValues.endDate || ""}
              onChange={(e) => onFilterChange && onFilterChange("endDate", e.target.value)}
            />
          </Col>
          </>
        )}

        {/* SHARE */}
        {selectedFilter === "Share" && (
          <>
          
            <Col className="custom_col">
              <AnimatedSelect
                value={filterValues.contentType || ""}
                options={[
                  { label: "Select Content Type", value: "" },
                  ...contentTypes.map((c) => ({
                    label: c,
                    value: c
                  }))
                ]}
                onChange={(value) => onFilterChange && onFilterChange("contentType", value)}
              />
            </Col>
            
            <Col className="custom_col">
              <AnimatedSelect
                value={filterValues.solutionType || ""}
                options={[
                  { label: "Select Solution Type", value: "" },
                  ...(SolutionList || []).map((item) => ({
                    label: item.name,
                    value: item.id
                  }))
                ]}
                onChange={(value) => onFilterChange && onFilterChange("solutionType", value)}
              />
            </Col>


            <Col className="custom_col">
              <AnimatedSelect
                value={filterValues.contentName || ""}
                options={[
                  { label: "Select Content Name", value: "" },
                  ...(ContentList || []).map((item) => ({
                    label: item.name,
                    value: item.id
                  }))
                ]}
                onChange={(value) => onFilterChange && onFilterChange("contentName", value)}
              />
            </Col>


            <Col className="custom_col">
              <AnimatedSelect
                value={filterValues.channelName || ""}
                options={[
                  { label: "Select Channel Name", value: "" },
                  ...(ChannelList || []).map((item) => ({
                    label: item.name,
                    value: item.name
                  }))
                ]}
                onChange={(value) => onFilterChange && onFilterChange("channelName", value)}
              />
            </Col>


            <Col className="custom_col">
              <Form.Control 
                type="number" 
                placeholder="Number of Shares" 
                value={filterValues.numberOfShares || ""}
                onChange={(e) => onFilterChange && onFilterChange("numberOfShares", e.target.value)}
              />
            </Col>
            <Col className="custom_col">
              <Form.Control 
                type="date" 
                placeholder="Start Date" 
                value={filterValues.shareStartDate || ""}
                onChange={(e) => onFilterChange && onFilterChange("shareStartDate", e.target.value)}
              />
            </Col>
            <Col className="custom_col">
              <Form.Control 
                type="date" 
                placeholder="End Date" 
                value={filterValues.shareEndDate || ""}
                onChange={(e) => onFilterChange && onFilterChange("shareEndDate", e.target.value)}
              />
            </Col>
          </>
        )}

        {/* GOT LEADS */}
        {selectedFilter === "Got Leads" && (
          <>
            <Col className="custom_col">
              <Form.Control 
                type="number" 
                placeholder="Number of Leads" 
                value={filterValues.numberOfLeads || ""}
                onChange={(e) => onFilterChange && onFilterChange("numberOfLeads", e.target.value)}
              />
            </Col>
            <Col className="custom_col">
              <Form.Control 
                type="date" 
                placeholder="Start Date" 
                value={filterValues.leadsStartDate || ""}
                onChange={(e) => onFilterChange && onFilterChange("leadsStartDate", e.target.value)}
              />
            </Col>
            <Col className="custom_col">
              <Form.Control 
                type="date" 
                placeholder="End Date" 
                value={filterValues.leadsEndDate || ""}
                onChange={(e) => onFilterChange && onFilterChange("leadsEndDate", e.target.value)}
              />
            </Col>
          </>
        )}

        {/* IMPORTED CONTACTS */}
        {selectedFilter === "Imported Contacts" && (
          <>
            <Col className="custom_col">
              <Form.Control 
                type="number" 
                placeholder="Number of Contacts"
                value={filterValues.numberOfContacts || ""}
                onChange={(e) => onFilterChange && onFilterChange("numberOfContacts", e.target.value)}
              />
            </Col>
            <Col className="custom_col">
              <Form.Control 
                type="date" 
                placeholder="Start Date"
                value={filterValues.contactsStartDate || ""}
                onChange={(e) => onFilterChange && onFilterChange("contactsStartDate", e.target.value)}
              />
            </Col>
            <Col className="custom_col">
              <Form.Control 
                type="date" 
                placeholder="End Date"
                value={filterValues.contactsEndDate || ""}
                onChange={(e) => onFilterChange && onFilterChange("contactsEndDate", e.target.value)}
              />
            </Col>
          </>
        )}

        {/* UPDATED PROFILE */}
        {selectedFilter === "Updated Profile" && (
          <>
            <Col className="custom_col">
              <Form.Control 
                type="date"
                placeholder="Start Date"
                value={filterValues.profileUpdatedStartDate || ""}
                onChange={(e) => onFilterChange && onFilterChange("profileUpdatedStartDate", e.target.value)}
              />
            </Col>
            <Col className="custom_col">
              <Form.Control 
                type="date"
                placeholder="End Date"
                value={filterValues.profileUpdatedEndDate || ""}
                onChange={(e) => onFilterChange && onFilterChange("profileUpdatedEndDate", e.target.value)}
              />
            </Col>
          </>
        )}

        {/* CREATED TASKS */}
        {selectedFilter === "Created Tasks" && (
          <>
            <Col className="custom_col">
              <Form.Control 
                type="number" 
                placeholder="Number of Tasks"
                value={filterValues.numberOfTasks || ""}
                onChange={(e) => onFilterChange && onFilterChange("numberOfTasks", e.target.value)}
              />
            </Col>
            <Col className="custom_col">
              <Form.Control 
                type="date" 
                placeholder="Start Date"
                value={filterValues.tasksStartDate || ""}
                onChange={(e) => onFilterChange && onFilterChange("tasksStartDate", e.target.value)}
              />
            </Col>
            <Col className="custom_col">
              <Form.Control 
                type="date" 
                placeholder="End Date"
                value={filterValues.tasksEndDate || ""}
                onChange={(e) => onFilterChange && onFilterChange("tasksEndDate", e.target.value)}
              />
            </Col>
          </>
        )}

        {/* OPENED NOTIFICATIONS */}
        {selectedFilter === "Opened Notifications" && (
          <>
            <Col className="custom_col">
              <Form.Control 
                type="number" 
                placeholder="Number of Opens"
                value={filterValues.numberOfOpens || ""}
                onChange={(e) => onFilterChange && onFilterChange("numberOfOpens", e.target.value)}
              />
            </Col>
            <Col className="custom_col">
              <Form.Control 
                type="date" 
                placeholder="Start Date"
                value={filterValues.notificationsStartDate || ""}
                onChange={(e) => onFilterChange && onFilterChange("notificationsStartDate", e.target.value)}
              />
            </Col>
            <Col className="custom_col">
              <Form.Control 
                type="date" 
                placeholder="End Date"
                value={filterValues.notificationsEndDate || ""}
                onChange={(e) => onFilterChange && onFilterChange("notificationsEndDate", e.target.value)}
              />
            </Col>
          </>
        )}

        {/* CLICKED LINKS */}
        {selectedFilter === "Clicked Links (in Email/WhatsApp/Push)" && (
          <>
            <Col className="custom_col">
              <AnimatedSelect
                value={filterValues.clickChannel || ""}
                options={[
                  { label: "Select Channel", value: "" },
                  { label: "Email", value: "Email" },
                  { label: "WhatsApp", value: "WhatsApp" },
                  { label: "Push", value: "Push" }
                ]}
                onChange={(value) => onFilterChange && onFilterChange("clickChannel", value)}
              />
            </Col>
            <Col className="custom_col">
              <Form.Control 
                type="number" 
                placeholder="Number of Clicks" 
                value={filterValues.numberOfClicks || ""}
                onChange={(e) => onFilterChange && onFilterChange("numberOfClicks", e.target.value)}
              />
            </Col>
            <Col className="custom_col">
              <Form.Control 
                type="text" 
                placeholder="campaign/link" 
                value={filterValues.specificCampaign || ""}
                onChange={(e) => onFilterChange && onFilterChange("specificCampaign", e.target.value)}
              />

            </Col>
          </>
        )}

        {/* COMPLETED ACTIONS / JOURNEYS */}
        {selectedFilter === "Completed Actions / Journeys" && (
          <>
            <Col className="custom_col">
              <AnimatedSelect
                value={filterValues.whichJourney || ""}
                options={[
                  { label: "Select Journey", value: "" },
                  ...campaign.map((item) => ({
                    label: item.name,
                    value: item.name
                  }))
                ]}
                onChange={(value) => onFilterChange && onFilterChange("whichJourney", value)}
              />
            </Col>
            <Col className="custom_col">
              <Form.Control 
                type="date" 
                placeholder="Start Date"
                value={filterValues.completionStartDate || ""}
                onChange={(e) => onFilterChange && onFilterChange("completionStartDate", e.target.value)}
              />
            </Col>
            <Col className="custom_col">
              <Form.Control 
                type="date" 
                placeholder="End Date"
                value={filterValues.completionEndDate || ""}
                onChange={(e) => onFilterChange && onFilterChange("completionEndDate", e.target.value)}
              />
            </Col>
          </>
        )}

    
    
        {/* AUTOEMAIL CONTACTS */}
        {selectedFilter === "AutoEmail Contacts" && (
          <Col className="custom_col">
            <AnimatedSelect
              value={filterValues.selectedList || ""}
              options={[
                { label: "Select List", value: "" },
                ...lists.map((item) => ({
                  label: item.name,
                  value: item.id
                }))
              ]}
              onChange={(value) => onFilterChange && onFilterChange("selectedList", value)}
            />
          </Col>
        )}

        {/* INACTIVE USERS */}
        {selectedFilter === "Inactive Users" && (
          <Col className="custom_col">
            <Form.Control 
              type="number" 
              placeholder="No activity in last n days" 
              value={filterValues.inactiveDays || ""}
              onChange={(e) => onFilterChange && onFilterChange("inactiveDays", e.target.value)}
            />
          </Col>
        )}

        {/* ACCOUNT CREATED ON */}
        {selectedFilter === "Account Created On" && (
          <>
            <Col className="custom_col">
              <Form.Control 
                type="date" 
                placeholder="Start Date" 
                value={filterValues.accountCreatedStartDate || ""}
                onChange={(e) => onFilterChange && onFilterChange("accountCreatedStartDate", e.target.value)}
              />
            </Col>
            <Col className="custom_col">
              <Form.Control 
                type="date" 
                placeholder="End Date" 
                value={filterValues.accountCreatedEndDate || ""}
                onChange={(e) => onFilterChange && onFilterChange("accountCreatedEndDate", e.target.value)}
              />
            </Col>
          </>
        )}

        {/* SOCIAL PAGES */}
        {selectedFilter === "Social Pages" && (
          <>
          <Col className="custom_col">
            <AnimatedSelect
              value={filterValues.selectedSocialPage || ""}
              options={[
                { label: "All socialPages", value: "all" },
                ...socialPages.map((item) => ({
                  label: item.name,
                  value: item.id
                }))
              ]}
              onChange={(value) => onFilterChange && onFilterChange("selectedSocialPage", value)}
            />
          </Col>
          
          <Col className="custom_col">
              <Form.Control 
                type="date" 
                placeholder="Start Date"
                value={filterValues.completionStartDate || ""}
                onChange={(e) => onFilterChange && onFilterChange("completionStartDate", e.target.value)}
              />
            </Col>
            <Col className="custom_col">
              <Form.Control 
                type="date" 
                placeholder="End Date"
                value={filterValues.completionEndDate || ""}
                onChange={(e) => onFilterChange && onFilterChange("completionEndDate", e.target.value)}
              />
            </Col>
</>
        )}
      </>
    );
  };

  export default UserBehaviorFilters;